import React from "react";
import VerifiedTrue from "../../assests/Green.svg";
import VerifiedFalse from "../../assests/Red.svg";

export const UrlFormatter = (cell) => {
    const maxLength = 30; // Maximum length of the displayed URL
    const truncatedURL = cell.length > maxLength ? cell.slice(0, maxLength - 3) + "..." : cell;
    return (
      <a href={cell} title={cell} target="_blank" rel="noopener noreferrer">
        {truncatedURL}
      </a>
    );
};
  